import laravelAxiosClient from "../laravelAxiosClient";
import {
  RevueNumeriqueResult,
  RevuesNumeriquesForUserResult,
} from "../interfaces/revues-numeriques.interface";

export const findRevuesNumeriquesForUser = async () => {
  const { data } = await laravelAxiosClient.get<RevuesNumeriquesForUserResult>(
    "/revues-numeriques/for-user"
  );
  return data;
};

export const findRevueNumerique = async (id: string) => {
  const { data } = await laravelAxiosClient.get<RevueNumeriqueResult>(
    `/revues-numeriques/${id}`
  );
  return data;
};
